import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import API from 'configs/API';

import EditArtworkSection from '../../../../commons/BoxSection';
import AddOwnerModal from './AddOwnerModal';
import EditArtworkEditionHead from './EditArtworkEditionHead';
import EditArtworkEditionItem from './EditArtworkEditionItem';

const EditArtworkEdition = ({ artworkFormState, artwork }) => {
  const { t } = useTranslation();
  const [isOwnerModalOpen, setIsOwnerModalOpen] = useState(false);
  const [selectedEditionIndex, setSelectedEditionIndex] = useState(null);

  const { control, trigger, watch } = artworkFormState;
  const artworkId = watch('artworkId');
  const { fields } = useFieldArray({
    control,
    name: 'editions',
    keyName: 'customId',
  });

  const { data: statusOptions, isPending } = useQuery({
    queryKey: [API.ARTWORK.STATUS],
  });
  const { data: locationOptions, isPending: isLocationPending } = useQuery({
    queryKey: [API.AUTH.LOCATION],
  });

  const handleEditionStatusChange = () => {
    trigger();
  };

  const handleOpenOwnerModal = (index) => {
    setSelectedEditionIndex(index);
    setIsOwnerModalOpen(true);
  };

  const handleCloseOwnerModal = () => {
    setIsOwnerModalOpen(false);
    setSelectedEditionIndex(null);
  };

  if (isPending || isLocationPending) {
    return;
  }

  if (fields?.length <= 0) {
    return;
  }

  return (
    <EditArtworkSection heading={t('status_and_location')}>
      <EditArtworkEditionHead />

      {fields.map((edition, index) => (
        <EditArtworkEditionItem
          key={edition.customId}
          edition={edition}
          index={index}
          control={control}
          statusOptions={statusOptions}
          locationOptions={locationOptions}
          onStatusChange={handleEditionStatusChange}
          onOpenOwnerModal={handleOpenOwnerModal}
          artwork={artwork}
        />
      ))}

      <AddOwnerModal
        open={isOwnerModalOpen}
        onClose={handleCloseOwnerModal}
        editionId={fields?.[selectedEditionIndex]?.id}
        initialData={fields?.[selectedEditionIndex]}
        artworkId={artworkId}
      />
    </EditArtworkSection>
  );
};

export default EditArtworkEdition;
